var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGoalOutline = function SvgGoalOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 21.503V4a.5.5 0 0 0-1 0v17.503a.5.5 0 0 0 1 0Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3.5c-.445 0-.445.397-.445.397v11.728c0 .25.07.375.365.375H19.5c.25 0 .25-.298.125-.399a62.653 62.653 0 0 1-.462-.379l-.118-.097L12.5 9.75s-.095-.09.104-.25l.293-.233.2-.16c1.51-1.202 4.722-3.76 5.936-4.732l.112-.09c.193-.154.319-.256.355-.286.314-.264.125-.499 0-.499H7Zm10.632.875c-1.716 1.37-4.612 3.675-5.573 4.44-.2.16-.446.44-.456.848a.972.972 0 0 0 .275.702l.01.01.005.005.002.002.001.001s.002.001.604-.633l-.602.634.022.022.025.02.555-.676-.555.676 1.095.9c.659.54 1.538 1.263 2.42 1.988l2.206 1.811H7.43V4.375h10.202Z",
    fill: "currentColor"
  })));
};
export default SvgGoalOutline;